import React from 'react';
import { buildTrialSourceUrl, toPatientFriendlyStatus } from '../utils/trialHelpers';

export default function TrialDetailDrawer({ trial, onClose, onToggleSave, onOpenMaps }) {
  if (!trial) return null;

  return (
    <div style={overlayStyle}>
      <div style={drawerStyle}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px', marginBottom: '12px' }}>
          <h3 style={{ margin: 0, fontSize: '19px', color: '#0f172a', lineHeight: 1.3 }}>Trial Details</h3>
          <button type="button" onClick={onClose} style={closeBtn}>Close</button>
        </div>

        <h4 style={{ margin: '0 0 8px', fontSize: '16px', color: '#111827' }}>{trial.fullTitle || trial.title}</h4>
        <p style={{ margin: '0 0 12px', fontSize: '13px', color: '#475569' }}>{trial.summary}</p>

        <DetailRow label="Trial ID" value={trial.trialIdentifier} />
        <DetailRow label="Institution / Site" value={trial.institution} />
        <DetailRow label="Address" value={`${trial.address}, ${trial.city}, ${trial.region}, ${trial.country}`} />
        <DetailRow label="Recruiting Status" value={toPatientFriendlyStatus(trial.recruitingStatus)} />
        <DetailRow label="Diagnosis Match" value={trial.matchReasons?.length ? trial.matchReasons.join(' ') : 'No direct diagnosis match was identified using current profile data.'} />
        <DetailRow label="Eligibility Summary" value={trial.eligibilitySummary} />
        <DetailRow label="Exclusion Summary" value={trial.exclusionSummary || 'Not provided'} />
        <DetailRow label="Biomarker / Genomic Relevance" value={(trial.biomarkers || []).length > 0 ? trial.biomarkers.join(', ') : 'No biomarker requirement listed'} />
        <DetailRow label="Contact" value={`${trial.contactName || 'N/A'} | ${trial.contactEmail || 'N/A'} | ${trial.contactPhone || 'N/A'}`} />

        <div style={{ marginTop: '14px', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
          <button type="button" onClick={() => onToggleSave(trial)} style={primaryBtn}>
            {trial.isSaved ? 'Unsave Trial' : 'Save Trial'}
          </button>
          <button type="button" onClick={() => onOpenMaps(trial)} style={ghostBtn}>
            Open in Maps
          </button>
          <button
            type="button"
            onClick={() => window.open(buildTrialSourceUrl(trial), '_blank', 'noopener,noreferrer')}
            style={ghostBtn}
          >
            Find More
          </button>
        </div>
      </div>
    </div>
  );
}

function DetailRow({ label, value }) {
  return (
    <div style={{ marginBottom: '10px' }}>
      <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '700' }}>{label}</div>
      <div style={{ marginTop: '2px', fontSize: '13px', color: '#1f2937', lineHeight: 1.45 }}>{value}</div>
    </div>
  );
}

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  zIndex: 1900,
  background: 'rgba(15, 23, 42, 0.44)',
  display: 'flex',
  justifyContent: 'flex-end',
};

const drawerStyle = {
  width: 'min(100vw, 520px)',
  height: '100vh',
  background: 'white',
  overflowY: 'auto',
  padding: '16px 14px 24px',
  boxShadow: '-8px 0 24px rgba(2, 6, 23, 0.2)',
};

const closeBtn = {
  border: '1px solid #cbd5e1',
  background: 'white',
  color: '#334155',
  borderRadius: '8px',
  padding: '7px 10px',
  cursor: 'pointer',
  fontSize: '12px',
  fontWeight: '700',
};

const primaryBtn = {
  border: 'none',
  borderRadius: '8px',
  background: 'var(--teal)',
  color: 'white',
  fontSize: '12px',
  fontWeight: '700',
  padding: '8px 11px',
  cursor: 'pointer',
};

const ghostBtn = {
  border: '1px solid #cbd5e1',
  borderRadius: '8px',
  background: 'white',
  color: '#334155',
  fontSize: '12px',
  fontWeight: '700',
  padding: '8px 11px',
  cursor: 'pointer',
};
